/* eslint-disable */
import React, { Component } from 'react'
import { Modal, View, Text, TouchableOpacity, Image, Dimensions } from 'react-native'
import { SvgArrowDown } from './SvgComponent'

export default class KargoeSelectorComponent extends Component {

  constructor(props) {
    super(props)
    this.state = { width : props.width, height : props.height
                 , selected : props.selected || { Index : 0 }, dim : Dimensions.get('window')
                 , modal : false // start hidden
                 , firstItemIsHeader : props.firstItemIsHeader // header will be bold and not selectable
                 }
  }
  Option = ( json ) => {
    //console.log("first item is header = " + this.state.firstItemIsHeader)
    let selected = (json.Index === this.state.selected)
    return (
      <TouchableOpacity disabled={this.state.firstItemIsHeader && json.Index === 0}
        style={{ flex : 1, height : this.state.dim.width * 0.1
               , borderWidth : 0.5, borderColor : '#cccccc70'
               , backgroundColor : (selected?'#4f5271':'white')
               , flex : 0.1, justifyContent : 'center', alignItems : 'center'
              }}
        onPress={( ) => {
         if (this.state.firstItemIsHeader && json.Index === 0) return
         this.toggleModalRowSelect()
         this.setState({ selected : json })
         this.props.onSelect( json )
        }}>
        <Text style={{ color : (selected?'white':'black'), textAlign : 'center', width : this.state.dim.width
                     , fontWeight: (this.state.firstItemIsHeader && json.Index === 0) ? 'bold' : 'normal' }}>
          { json.Title }
        </Text>
      </TouchableOpacity>
    )
  }
  toggleModal = () => { // top level we do an extra check to not dismiss if first item had a header
    if (this.state.firstItemIsHeader && this.state.modal == true) return // for this case we dont want to dismiss modal if user taps on header
    // modal is dismissed anyway when a selection is made
    this.setState((state) => ({ modal: !state.modal })) 
  }
  toggleModalRowSelect = () => {
    this.setState((state) => ({ modal: !state.modal })) 
  }
  render( ) {
    //console.log("this.props.options " + JSON.stringify(this.props.options))
    //console.log("this.state.selected.Index " + JSON.stringify(this.state.selected.Index))
    let selection = this.props.options [ this.state.selected.Index ]
    let { Title = '', Index = 0, Name = '' } = (selection ? selection : {})
    const { red, wrapperStyle, inputStyle } = this.props
    const extraTextStyling = (red && typeof Name === 'undefined') ? {color: '#ff0000'} : {}
    //console.log("ready to show Title = " + Title + " Name = " + Name)
    //console.log("length Title = " + Title.length + " length Name = " + Name.length)
    return (
      <View
        style={[
          {flex:0.9, flexDirection: 'column', width : this.state.width, height : this.state.height * 0.75, margin : 10 },
          wrapperStyle
        ]}
      >
        <Modal
          animationType="fade"
          transparent={true}
          visible={this.state.modal}>
          <TouchableOpacity onPress={this.toggleModal} activeOpacity={1.0}
                style={{ flex : 1, height: this.state.dim.height
                       , backgroundColor : '#00000070', flexDirection : 'column', justifyContent : 'flex-end', alignItems : 'center' }}>
            { this.props.options .map ( this.Option ) }
          </TouchableOpacity>
        </Modal>
        <TouchableOpacity
          style={[{ flexDirection : 'row', justifyContent : 'space-between'
                  , alignItems : 'center', borderColor : 'black', borderWidth : 1, borderRadius : 5 }, inputStyle]}
          activeOpacity={0.5}
          onPress={this.toggleModal}>

          <Text style={[{height : this.state.height * 0.75, fontSize : 14, color : 'black', paddingLeft : 10
            , textAlign : 'center', lineHeight: this.state.height*0.75 } , extraTextStyling]}>
            {(typeof Name === 'undefined' || Name.trim() == "" || Name.length == 0) ? Title : Name /* if we use name it seems to not display sometimes maybe too long? */}
          </Text>
          { this.props.chevron
            ? (<View style={{ paddingRight : 10 }}><SvgArrowDown size={15}/></View>)
            : (<Text></Text>)
          }

        </TouchableOpacity>
      </View>
    )
  }
}
